import React, { Component } from "react";

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      height: "100",
      src:
        "https://datastudio.google.com/embed/reporting/1_m-QDhCSq3M-8pIANOmaztBhaaKeRj5Z/page/wevJB"
    };
  }
  render() {
    return (
      <div className="iframe-wrapper" style={{height:"450px"}}>
       <iframe
          src={this.state.src}
          //src=""
          frameborder="0"
          width="100%"
          height="100%"
          allowtransparency
          //onLoad={this.iframeLoad}
        ></iframe>
        {/* <iframe
          
          src={this.state.src}
        ></iframe> */}
      </div>
    );
  }
}

export default Reports;



// WEBPACK FOOTER //
// ./src/views/ISEAS/Reports/index.js